/* BFP Holiday Wonderland: lightweight snowfall; no click capture, no motion when requested. */
(function(){
 if(window.__bfpHolidaySnowInitialized)return;
 window.__bfpHolidaySnowInitialized=true;
 function start(){
   var holder=document.getElementById('bfp-holiday-snow');
   if(!holder || !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
   var mobile=window.matchMedia('(max-width:749px)').matches;
   var count=mobile?22:42;
   var frag=document.createDocumentFragment();
   for(var i=0;i<count;i++){
     var f=document.createElement('span');
     f.className='bfp-holiday-flake';
     f.setAttribute('aria-hidden','true');
     f.textContent='❄';
     f.style.left=(Math.random()*100)+'%';
     f.style.fontSize=(8+Math.random()*(mobile?9:14))+'px';
     f.style.opacity=(.38+Math.random()*.48).toFixed(2);
     f.style.animationDuration=(10+Math.random()*14)+'s';
     f.style.animationDelay=(-Math.random()*24)+'s';
     f.style.setProperty('--bfp-snow-drift',(Math.random()*90-45)+'px');
     frag.appendChild(f);
   }
   holder.appendChild(frag);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();